<template>
  <div>
    <div
      class="place-wrapper reserved"
      v-if="isReservedPlace(place)"
      :style="{
        left: Math.round(place.X) * scaleValue + 'px',
        top: Math.round(place.Y) * scaleValue + 'px',
        background: '#59636b',
        width: 20 * scaleValue + 'px',
        height: 20 * scaleValue + 'px',
        fontSize: 16 * scaleValue + 'px',
      }"
    >
      <div class="place">
        {{ place.Number }}
      </div>
    </div>
    <div
      class="place-wrapper"
      v-else
      :style="{
        left: Math.round(place.X) * scaleValue + 'px',
        top: Math.round(place.Y) * scaleValue + 'px',
        background: getPlaceColor,
        width: 20 * scaleValue + 'px',
        height: 20 * scaleValue + 'px',
        fontSize: 16 * scaleValue + 'px',
      }"
      @click="changePlaceInCart"
      :class="[{ added: addedClass }]"
    >
      <div class="place">
        {{ place.Number }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { types } from '@/types';
import { find, indexOf, filter } from 'lodash';

export default {
  name: 'Place',

  props: {
    place: {},
    scaleValue: {},
  },

  computed: {
    ...mapState(['session', 'cart', 'errors', 'places', 'setting', 'movie', 'theatre']),
    getPlaceColor() {
      let color = '';
      if (this.session.Prices.length) {
        this.session.Prices.forEach((item) => {
          if (item.Id === this.place.TypeId) {
            color = item.Color.slice(0, -2);
          }
        });
      }

      return color;
    },
    addedClass() {
      if (this.cart && this.place) {
        let placeInCart = find(this.cart.tickets, ['id', this.place.Id]);

        return typeof placeInCart === 'object'
      }

      return false
    },
  },

  methods: {
    isReservedPlace: (place) => place.Status !== 1,
    changePlaceInCart() {
      let placeInCart = find(this.cart.tickets, ['id', this.place.Id]);
      let index = indexOf(this.cart.tickets, placeInCart);

      let placesForCart = [];

      if (this.place.FragmentId) {
        let placeGroup = filter(this.places, (item) => {
          return item.FragmentId === this.place.FragmentId;
        });

        placeGroup.forEach((place) => {
          let placePrice = find(this.session.Prices, ['Id', place.TypeId]);

          placesForCart.push({
            price: placePrice.Sum,
            variants: [
              ...placePrice.Discounts.map(({ Name, Sum, TicketId }) => ({
                Name,
                Sum,
                TicketId,
                typeId: TicketId,
              })),
              {
                typeId: placePrice.TicketId,
                Name: placePrice.TicketName,
                Sum: placePrice.Sum,
              },
            ],
            name: placePrice.Name,
            typeId: placePrice.TicketId,
            id: place.Id,
            row: place.Row,
            number: place.Number,
          });
        });
      } else {
        let placePrice = find(this.session.Prices, ['Id', this.place.TypeId]);

        placesForCart.push({
          price: placePrice.Sum,
          variants: [
            ...placePrice.Discounts.map(({ Name, Sum, TicketId }) => ({
              Name,
              Sum,
              TicketId,
              typeId: TicketId,
            })),
            {
              typeId: placePrice.TicketId,
              Name: placePrice.TicketName,
              Sum: placePrice.Sum,
            },
          ],
          name: placePrice.Name,
          typeId: placePrice.TicketId,
          id: this.place.Id,
          row: this.place.Row,
          number: this.place.Number,
        });
      }

      if (index !== -1) {
        this.unreservePlace(placesForCart);
      } else {
        this.reservePlace(placesForCart);
      }
    },

    unreservePlace(placesForCart) {
      placesForCart.forEach((place) => {
        let placeInCart = find(this.cart.tickets, ['id', place.id]);

        let index = indexOf(this.cart.tickets, placeInCart);
        this.$store.dispatch('logRemoveTicket', {
          place: place,
          index,
        });

        // console.log(place, 'placeRemove')

        // eslint-disable-next-line no-undef
        // dataLayer.push({ ecommerce: null });  // очистка уровня данных.
        // // eslint-disable-next-line no-undef
        // dataLayer.push({
        //   'ecommerce': {
        //     'currencyCode': 'RUB',
        //     'add': {
        //       'products':   [
        //           {
        //             'id': place.id,              // где film_id это id фильма или товара.
        //             'name': place.name,          // где film_name это название фильма или товара.
        //             'price': place.price,      // где ticket_price это цена за билет или товар.
        //             'category': this.movie.Genres.join(', '),  // где category_name это название категории фильма.
        //             'brand': this.theatre.NameFull,           // где cinema это название кинотеатра.
        //             'variant': this.session.DateTime,      // где date-time это дата и время фильма.
        //             'quantity': '1'
        //           }
        //       ]
        //     }
        //   },
        //   'event': 'gtm-ee-event',
        //   'gtm-ee-event-category': 'Enhanced Ecommerce',
        //   'gtm-ee-event-action': 'Adding a Product to a Shopping Cart',
        //   'gtm-ee-event-non-interaction': 'False'
        // });
      });
    },

    reservePlace(placesForCart) {
      let currentCartTicketCount = this.cart.tickets.length;
      let maxSeats = this.setting.maxSeats ? this.setting.maxSeats : 5;
      if (currentCartTicketCount + placesForCart.length > maxSeats) {
        this.$store.commit(
          types.ADD_ERROR,
          `Максимальное возможное количество мест для выбора не должно превышать ${maxSeats}шт.`,
        );
        this.$store.commit(types.CLEAR_ERRORS, 3000);

        return;
      }

      placesForCart.forEach((place) => {
        this.$store.dispatch('logAddTicket', {
          place: place,
        });


        // console.log(place, 'placeAdd')

        // eslint-disable-next-line no-undef
        // dataLayer.push({ ecommerce: null });  // очистка уровня данных.
        // // eslint-disable-next-line no-undef
        // dataLayer.push({
        //   'ecommerce': {
        //     'currencyCode': 'RUB',
        //     'add': {
        //       'products':   [
        //           {
        //             'id': place.id,              // где film_id это id фильма или товара.
        //             'name': place.name,          // где film_name это название фильма или товара.
        //             'price': place.price,      // где ticket_price это цена за билет или товар.
        //             'category': this.movie.Genres.join(', '),  // где category_name это название категории фильма.
        //             'brand': this.theatre.NameFull,           // где cinema это название кинотеатра.
        //             'variant': this.session.DateTime,      // где date-time это дата и время фильма.
        //             'quantity': '1'
        //           }
        //       ]
        //     }
        //   },
        //   'event': 'gtm-ee-event',
        //   'gtm-ee-event-category': 'Enhanced Ecommerce',
        //   'gtm-ee-event-action': 'Removing a Product',
        //   'gtm-ee-event-non-interaction': 'False'
        // });
      });
    },
  },
};
</script>

<style lang="scss">
.place-wrapper {
  position: absolute;
  box-sizing: border-box;
  background: rgb(89, 99, 107);
  color: rgb(89, 99, 107);
  text-align: center;
  font-weight: 700;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;
  border-radius: 50%;
  &:before {
    content: '';
    position: absolute;
    top: -5px;
    right: -5px;
    bottom: -5px;
    left: -5px;
    background-color: inherit;
    opacity: 0;
    z-index: 20;
    transition: opacity 0.2s ease-in-out;
    border-radius: 50%;
  }
  &:not(.reserved):hover {
    cursor: pointer;
    .place {
      color: #000 !important;
    }
    &:before {
      opacity: 1;
    }
  }
  &.added {
    box-sizing: unset;
    background: #fff !important;
    border-radius: 50%;
    border-width: 3px;
    transition: border-radius 0.3s ease-in-out, border-color 0.3s ease-in-out,
      background 0.3s ease-in-out;
    &:hover {
      &:before {
        opacity: 0;
      }
    }
    .place {
      color: #000 !important;
    }
  }
}

.place {
  width: 100%;
  z-index: 30;
  transition: color 0.15s ease-in-out;
  color: transparent;
}
</style>
